// Liste d'articles : grille Isotope (masonry), filtre par thématique, bouton « En voir plus »
export function initBlogList($) {
  var $wrap = $('.blog-list--masonry')
  if (!$wrap.length) return

  var PER_PAGE = 9
  var limit = PER_PAGE
  var selector = '*'
  var $items = $wrap.find('.blog-list--item')
  var $more = $('.blog-list--more')

  var $grid = $wrap.isotope({ itemSelector: '.blog-list--item', percentPosition: true, layoutMode: 'masonry' })
  $wrap.find('img').on('load', function () { $grid.isotope('layout') })
  $(window).on('load', function () { $grid.isotope('layout') })

  function apply() {
    var $matched = selector === '*' ? $items : $items.filter(selector)
    var $shown = $matched.slice(0, limit)
    $grid.isotope({ filter: function () { return $shown.index(this) > -1 } })
    $more.toggle($matched.length > limit)
  }

  $('.blog-list--filter li').on('click', function () {
    selector = $(this).attr('data-filter')
    limit = PER_PAGE
    $('.blog-list--filter li').removeClass('is-active')
    $(this).addClass('is-active')
    apply()
  })

  $('.blog-list--more-btn').on('click', function () {
    limit += PER_PAGE
    apply()
  })

  apply()
}
